import React from "react";

interface IconProps {
  width?: number | string;
  height?: number | string;
}

export const Icon = () => {
  return (
    <div>
      Icon Root component.
      If you see this message try using a subcomponent
      eg. Icon.Info, Icon.Question
    </div>
  );
};

const InfoIcon = () => {
  return (
    <span className="info-popover">i</span>
  );
};

const QuestionIcon = () => {
  return (
    <span className="info-popover">?</span>
  );
};

const generateStyle = (width?: number | string, height?: number | string) => ({
  width: width || 20,
  minWidth: width || 20,
  height: height || 20,
  minHeight: height || 20,
});

const ShieldIcon = ({ width, height }: IconProps) => {
  return (
    <div className="shieldIcon" style={ generateStyle(width, height) } />
  );
};

const ClockIcon = ({ width, height }: IconProps) => {
  return (
    <div className="clockIcon" style={ generateStyle(width, height) } />
  );
};

const FingerprintIcon = ({ width, height }: IconProps) => {
  return (
    <div className="fingerprintIcon" style={ generateStyle(width, height) } />
  );
};

const TickIcon = ({ width, height }: IconProps) => {
  return (
    <div className="tickIcon" style={ generateStyle(width, height) }></div>
  );
};

Icon.Info = InfoIcon;
Icon.Question = QuestionIcon;
Icon.Shield = ShieldIcon;
Icon.Clock = ClockIcon;
Icon.Fingerprint = FingerprintIcon;
Icon.Tick = TickIcon;
